import { useMutation } from 'react-query';
import { ProjectMilestonesApi } from '../../../api/ProjectApi/ProjectMilestonesApi';
import { useInvalidateProjectMilestones } from './useProjectMilestones';

export const useProjectMilestoneReorder = () => {
  const invalidateMilestones = useInvalidateProjectMilestones();

  return useMutation(ProjectMilestonesApi.patchMilestoneReorder, {
    onSuccess: (_, input) => {
      invalidateMilestones(input.projectUid);
    },
  });
};
